import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { AuthService } from 'app/auth/auth.service';
import { PERM_ADMINISTRATE_SYSTEM } from 'app/common/common/constants/permissions';
import { Message } from 'app/common/common/message/message.component';
import { BHistory } from 'app/modules/data-model/data-model.module';
import { InteractionsService } from 'app/modules/data-model/interaction/interactions.service';
import { BDMMessage } from 'app/modules/data-model/message/message';

@Component({
  selector: 'app-history-visualization-detail',
  templateUrl: './history-visualization-detail.component.html',
})
export class HistoryVisualizationDetailComponent implements OnInit, OnDestroy {
  historyObject: BHistory;
  categoryTitleKey: string;
  historyMessage: BDMMessage;
  loggedInUserIsSysAdmin: boolean = false;
  message: Message;

  private subs = new Subscription();

  constructor(private interactionsService: InteractionsService, private authService: AuthService) {}

  ngOnInit(): void {
    this.subs.add(
      this.authService.permissions.subscribe((handler) => {
        this.loggedInUserIsSysAdmin = handler.has(PERM_ADMINISTRATE_SYSTEM);
      })
    );
    if (!this.historyObject.mergedFromInteractionId && this.historyObject.category !== 'error') {
      this.subs.add(
        this.interactionsService.getHistoryMessage(this.historyObject.id).subscribe({
          next: (message) => (this.historyMessage = message),
          error: (error) => (this.message = Message.httpError('Load History Message', error)),
        })
      );
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
